import {useLayoutEffect, useState} from "react";

// Position of a "thumb" that slides behind the selected option of a segmented control.
// `containerRef` is the (position: relative) control and each option carries `data-key`.
// Returns a style to put on the thumb (null until the option is found), so the thumb can be
// moved with `transform` and animated with a CSS transition. It re-measures whenever the
// control changes size, e.g. once the web font has loaded or an option gets wider.
export const useSlidingThumb = (containerRef, activeKey) => {
    const [style, setStyle] = useState(null);

    useLayoutEffect(() => {
        const container = containerRef.current;
        if (!container || activeKey == null) return;

        const measure = () => {
            const option = container.querySelector(`[data-key="${activeKey}"]`);
            if (!option) return;
            setStyle({
                width: option.offsetWidth,
                height: option.offsetHeight,
                transform: `translate(${option.offsetLeft}px, ${option.offsetTop}px)`,
            });
        };
        measure();

        const observer = new ResizeObserver(measure);
        observer.observe(container);
        return () => observer.disconnect();
    }, [containerRef, activeKey]);

    return style;
};
